import { ResponseError } from '@marketplace-web/core-api/api-client-util'
import { api } from '@marketplace-web/core-api/core-api-client-util'

import { GetTransactionArgs, GetTransactionResp } from '../types/transaction'
import { VerificationPromptResp } from '../types/verification'
import { FaqNotLoggedInEntriesResp } from '../types/faq-not-logged-in-entries'

import {
  CreateSupportTicketArgs,
  CreateSupportTicketResp,
  getCreateSupportTicketArgs,
} from './types'
import { HelpCenterRecentUsersResp } from '../types/help-center-recent-users'

const moneyObjectHeader = {
  'X-Money-Object': 'true',
}

export const createSupportTicket = (args: CreateSupportTicketArgs) =>
  api.post<CreateSupportTicketResp, ResponseError>(
    '/help_center/support_tickets',
    getCreateSupportTicketArgs(args),
  )

export const getFaqNotLoggedInEntries = () =>
  api.get<FaqNotLoggedInEntriesResp>('/faq_entries/not_logged_in')

export const getTransaction = ({ id }: GetTransactionArgs) =>
  api.get<GetTransactionResp>(`/transactions/${id}`, { headers: moneyObjectHeader })

export const getVerificationPrompt = (userId: number) =>
  api.get<VerificationPromptResp>(`/users/${userId}/verifications/prompt`)

export async function getHelpCenterRecentUsers(keyword?: string) {
  return api.get<HelpCenterRecentUsersResp>('/help_center/recent_users', {
    params: { keyword },
  })
}
